<template>
  <div :style="{ height: '100vh', overflow: 'hidden'  }" :class="pageGray ? 'gray-scale' : ''">
    <div class="dianti_wrap" v-if="showFloor">
      <!-- <div class="dianti_center"> -->
      <div style="width: 1346px; margin: auto; position: relative">
        <div
          style="
            width: 105px;
            position: absolute;
            left: -127px;
            text-align: end;
          "
        >
          <div
            v-for="(item, index) in liftData"
            :key="index"
            class="lift_item"
            :class="{ active: activeIndex == index }"
            @mouseenter="enterFloor(item, index)"
            @mouseleave="leaveFloor(item)"
            @click="scrollFloor(item, index)"
          >
            <div class="lift_title">
              {{
                activeIndex == index
                  ? item.json_data.data.titleName
                  : mouseIndex == index
                  ? item.json_data.data.titleName
                  : index + 1 + "F"
              }}
            </div>
            <div class="lift_line" v-if="activeIndex == index"></div>
            <div style="width:2px;height: 12px;" v-else></div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div style="height: 100%; overflow: auto" ref="scrollPage">
      <div class="home_adv_con" v-if="showTopImage" >
        <div class="home_adv" :style="'background-image:url(' + topImg + ')'" @click="dragEvent(topData),navTo(topInfo)">
          <!-- :style="'background-image:url(' + topImg + ')'" -->
          <!-- <div class="adv1200">
            
          </div> -->
        </div>
        <div class="close1" @click.stop="closeAd()">
          <img src="../../assets/adv_close_icon.png" alt="">
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            width="16"
            height="16"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
          </svg> -->
        </div>
      </div>
      <NavTopBar />
      <SldHomeTopSearch :showSearch="searchBarFixed" />
      <NavCatHeader />
      <div class="index">
        <template v-if="firstLoading">
          <div class="skeleton_banner"></div>
          <div class="w_sld_react_1210 adv_04_wrap skeleton">
            <div class="floor_title">
              <h2>
                <div>&nbsp;</div>
                <span></span>
                <div>&nbsp;</div>
              </h2>
            </div>
            <div class="floor_goods">
              <div
                class="item"
                v-for="(item_main, index_main) in [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
                ]"
                v-bind:key="index_main"
              >
                <div class="wrap">
                  <a href="javascript:void(0)" class="example_text"></a>
                  <p class="title">
                    <a href="javascript:void(0)">{{ item_main }}</a>
                  </p>
                  <p class="price">
                    <span></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>

        <SldDiy
          ref="sldDiyRef"
          v-if="decorateData.data.length"
          :decorateData="decorateData"
          @adv19="handleAdv19"
          @getDada="getDada"
          :background="pageColor"
          :banner="bannerList"
        />
        <OpenScreen
          @closeScreen="closeScreen"
          :advImg="advImg"
          :advInfo="advInfo"
          :advData="advData"
          v-if="showXcxImage"
        >
        </OpenScreen>
        <!-- 空页面 start-->
        <SldCommonEmpty
          v-if="!firstLoading && !decorateData.data.length"
          totalHeight="900"
          paddingTop="250"
          :tip="L['我们正在努力装修中，敬请期待～']"
        />
        <!-- 空页面 end-->
         <KefuSlip class="side_menu" @goTop="goTop" :showGotoTop="true" :style="sideStyle" :couponIData="couponData"></KefuSlip>
      </div>
      <FooterService />
      <FooterLink />
    </div>
  </div>
</template>
<script>
import { reactive, getCurrentInstance, ref, onMounted, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  handleTime,
  getTodayStartTimestamp,
  getTodayEndTimestamp,
} from "../../utils/common";
import SldDiy from "../../components/SldDiy";
import OpenScreen from "../../components/OpenScreen";
import { useStore } from "vuex";
import SldCommonEmpty from "../../components/SldCommonEmpty";
import NavTopBar from "../../components/NavTopBar";
import SldHomeTopSearch from "../../components/SldHomeTopSearch";
import NavCatHeader from "../../components/NavCatHeader";
import FooterService from "../../components/FooterService";
import FooterLink from "../../components/FooterLink";
import KefuSlip from '../../components/KefuSlip'

import {title} from '../../utils/config';

export default {
  name: "index",
  components: {
    SldDiy,
    OpenScreen,
    SldCommonEmpty,
    NavTopBar,
    SldHomeTopSearch,
    NavCatHeader,
    FooterService,
    FooterLink,
    KefuSlip
  },
  setup() {
  
    const router = useRouter();
    const route = useRoute();
    const adv_21_right_icon = require("../../assets/decorate/right_more_icon.png");
    const adv_24_let_default_pic = require("../../assets/decorate/adv_24_let_default_pic.png");
    const decorateData = reactive({ data: [] }); //装修数据
    const openScreenData = reactive({ data: {} }); //开屏数据
    const firstLoading = ref(true); //是否第一次加载
    const { proxy } = getCurrentInstance();
    const show_open_screen = ref(true);
    const store = useStore();
    const L = proxy.$getCurLanguage();
   
    const showCoupon = ref(false);
    const activeIndex = ref(null);
    const sldDiyRef = ref(null);
    const scrollPage = ref(null);

    const advTop = ref([]);
    const topAdvs = ref([]);
    const topList = ref([]);
    const topImg = ref("");
    const topInfo = ref({});
    const advData = ref({});
    const topData = ref({})
    const showTopImage = ref(false);
    const liftData = ref([]);
    const couponData = ref([]);
    const mouseIndex = ref(null);
    const showSideMenu = ref(false);
    const showFloor = ref(false);
    const searchBarFixed = ref(false);
    const advList = ref([]);
    const advImg = ref("");
    const advInfo = ref({});
    const showXcxImage = ref(false);
    const pageColor = ref("");
    const pageGray = ref(false);
    const bannerList = ref([]);
    const memberInfo = ref(store.state.memberInfo);

    const sideStyle = ref('');

    const navList = ref([{categoryName:''}]);

    const closeAd = () => {
      // 隐藏广告
      document.querySelector(".home_adv_con").style.display = "none";
    };
    const getAdv = () => {
     
      proxy.$post("v3/system/front/pcAdv/list").then((res) => {
        if (res.state == 200) {
          advTop.value = res.data.openAdvs;
          topAdvs.value = res.data.topAdvs;
          let banner = res.data.bannerAdvs;
          if (banner.length == 0) {
            bannerList.value = [];
          } else {
            banner.forEach((i) => {
              let item = JSON.parse(i.data);
              item.toufangIsShow = true;
              if (item.deliverySettings) {
                if (!handleTime(item.deliveryTime)) {
                  item.toufangIsShow = false;
                } else {
                  if (item.deliveryGroup != 1) {
                    //根据个人信息判断展不展示
                    item.toufangIsShow = false;

                    if(item.memberType && item.memberType.length > 0){
                      //判断是否是新成员
                      if(item.memberType.includes("new")){
                        if(memberInfo && memberInfo.value && memberInfo.value){
                            item.toufangIsShow = true
                          }
                      }

                      //判断会员类型
                      if(!item.toufangIsShow && item.memberType.includes("designated")){
                        if(item.designatedMemberType && item.designatedMemberType.length > 0){
                          if(memberInfo && memberInfo.value && memberInfo.value.memberCategoryId){
                            item.toufangIsShow = item.designatedMemberType.includes(memberInfo.value.memberCategoryId)
                          }
                        }
                      }
                    } 
                  }
                }
              }
              i.datas = item;
            });
            bannerList.value = banner.filter(
              (e) => e.datas.toufangIsShow && e.datas.imgUrl
            );
            console.log("bannerList.value========", bannerList.value);
          }

          if (advTop.value && advTop.value.length != 0) {
            let time = new Date().getTime();
            let showAdvTime = localStorage.getItem("showAdvTime");
            if (showAdvTime && showAdvTime >= time) {
            } else {
              advTop.value.forEach((item) => {
                item.data = JSON.parse(item.data);
              });
              // this.advList = advList;
              let storeList = localStorage.getItem("advList");
              if (storeList && storeList.length !== 0) {
                advList.value = advTop.value.map((obj) => {
                  let objToMerge = storeList.find((o) => o.advId == obj.advId);
                  return Object.assign({}, objToMerge, obj);
                });
              } else {
                advList.value = advTop.value;
              }
              let hasShow = advList.value.filter((item) => !item.showAdv);
              if (hasShow.length == 0) {
                advList.value.forEach((v) => {
                  v.showAdv = false;
                });
              }

              if (advList.value.length != 0 && !store.state.firstShowAdv) {
                for (let i = 0; i < advList.value.length; i++) {
                  if (!advList.value[i].showAdv) {
                    let time = new Date().getTime();
                    if (
                      advList.value[i].showTime &&
                      advList.value[i].showTime >= time
                    ) {
                    } else {
                      advList.value[i].showAdv = true;
                      console.log(advList);
                      advImg.value = advList.value[i].data.imgUrl;
                      advList.value[i].showTime = getTodayEndTimestamp();
                      advInfo.value = advList.value[i].data;
                      advData.value = advList.value[i]
                      showXcxImage.value = true;
                      console.log("advImg", advImg.value);
                      break;
                    }
                    // console.log(i, this.advList[i], this.advList[i].showAdv)
                  }
                }
                // console.log("advList", this.advList)
                store.commit("setAdvList", advList.value);
                // localStorage.setItem("advList", advList.value)
                store.commit("setFirstShowAdv", true);
                let endTime = getTodayEndTimestamp();
                localStorage.setItem("showAdvTime", endTime);
              }
            }
          }

          if (topAdvs.value && topAdvs.value.length != 0) {
            let time = new Date().getTime();
            let showTopTime = localStorage.getItem("showTopTime");
            if (showTopTime && showTopTime >= time) {
            } else {
              topAdvs.value.forEach((item) => {
                item.data = JSON.parse(item.data);
              });
              let storeList = localStorage.getItem("topList");
              if (storeList && storeList.length !== 0) {
                topList.value = topAdvs.value.map((obj) => {
                  let objToMerge = storeList.find((o) => o.advId == obj.advId);
                  return Object.assign({}, objToMerge, obj);
                });
              } else {
                topList.value = topAdvs.value;
              }
              let hasShow = topList.value.filter((item) => !item.showAdv);

              if (hasShow.length == 0) {
                topList.value.forEach((v) => {
                  v.showAdv = false;
                });
              }

              if (topList.value.length != 0 && !store.state.firstShowTop) {
                for (let i = 0; i < topList.value.length; i++) {
                  if (!topList.value[i].showAdv) {
                    // console.log(i, this.advList[i], this.advList[i].showAdv)

                    topList.value[i].showAdv = true;

                    topImg.value = topList.value[i].data.imgUrl;
                    topInfo.value = topList.value[i].data;
                    topData.value = topList.value[i]
                    showTopImage.value = true;
                    break;
                  }
                }
                let endTime = getTodayEndTimestamp();
                localStorage.setItem("showTopTime", endTime);
                console.log("topList", topList.value);
                store.commit("setTopList", topList.value);
                store.commit("setFirstShowTop", true);
              }
            }
          }
        }
      });
    };
    const navTo = (topInfo) => {
      proxy.$diyNavTo(topInfo);
    };
    const getInitData = () => {

      //document.title = "华硕商城ASUS_华硕官网_华硕电脑官方直营商城，购笔记本电脑、轻薄本、游戏本、享一年意外险"

      let param = {};
      if (route.query.type == "view" && route.query.id)
        param.decoId = route.query.id;
      let draft = route.query.draft;
      let preview = route.query.type == 'view';
      let url = preview ? 'v3/system/front/pcDeco/display' : 'v3/system/front/pcDeco/index';

      if(window.innerHeight > 570){
        let top = (window.innerHeight - 450) / 2
        sideStyle.value = 'top:' + top + 'px'
      } else{
        sideStyle.value = 'top:120px'
      }
      
      proxy.$get(url, param).then((res) => {
        firstLoading.value = false;
        if (res.state == 200) {

          if (draft == 1) {
            decorateData.data = JSON.parse(
              res.data.draft.replace(/&quot;/g, '"')
            );
          } else {
            decorateData.data = JSON.parse(
              res.data.data.replace(/&quot;/g, '"')
            );
          }
          console.log('hhhhh',decorateData);

          decorateData.data.map((item) => {
            item.json_data = item.json;
            if (item.json_data && item.json_data.type == "adv_19") {
              item.json_data.data.map((child) => {
                child.cur_tab = 0;
              });
            }
            if (item.json_data && item.json_data.type == "main_banner") {
              pageColor.value = item.page_color;
              pageGray.value = item.page_gray;
            }
            if (item.json_data && item.json_data.type == "oneEight") {
              let ids = [];
              item.json_data.imgArr.forEach((i) => {
                ids.push(i.productId);
              });
              getProductData(ids, item.json_data.id);
            } else if (item.json_data && item.json_data.type == "twoEight") {
              let twoIds = [];
              item.json_data.imgArr.forEach((i) => {
                twoIds.push(i.productId);
              });
              getProductData(twoIds, item.json_data.id);
            } else if (item.json_data && item.json_data.type == "zeroFive") {
              let zeroIds = [];
              item.json_data.imgArr.forEach((i) => {
                zeroIds.push(i.productId);
              });
              getProductData(zeroIds, item.json_data.id);
            }
          });

          liftData.value = decorateData.data.filter(
            (i) => i.json_data.type == "text_title"
          );
          let couponData = decorateData.data.filter(
            (i) => i.json_data.type == "coupon_fixed" && i.json_data.state != 4
          );
          console.log('couponData===',couponData)
          if (couponData.length != 0) {
            getCouponList(couponData[0].json_data);
          } else {
            showCoupon.value = false;
          }
          store.commit("saveCouponList", couponData);
          store.commit("saveShowCoupon", showCoupon);

          console.log(11, decorateData.data);

          let navData = decorateData.data.filter((i) => i.json_data.type == "bottom_area" );
          console.log("navData====",navData)
          if(navData.length > 0){
          
            let navItems = []
            navData[0].json_data.data.forEach((item) => {
              console.log("navData[0].item====",item)
              console.log("navData[0].item===categoryName=",item.categoryName)
              navItems.push({
                categoryName:item.name,articleId:item.id,articleList:item.children
              })
            });
            navList.value = navItems
            store.commit("updateNavList", navItems);
            // console.log("navItems------&&&&&",navItems)
          }
          
          // let data = decorateData.data.filter(
          //   (i) => i.json_data.type == "text_title"
          // );
          // proxy.$emit("childData", data);
        }
      });
    };
    const getProductData = async (arr, id) => {
      let config = {
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
      };
      let param = {
        productIds: arr,
      };
      proxy
        .$post("v3/goods/front/goods/productList", param, config)
        .then((res) => {
          if (res.state == 200) {
            res.data.list.forEach((i) => {
              i.fresh = true;
            });
            decorateData.data.map((item) => {
              if (item.json_data.id == id) {
                // item.json_data.info = res.data.list;
                let mergedArray = item.json_data.imgArr.map((item1) => {
                  let item2 = res.data.list.find(
                    (items) => items.productId == item1.productId
                  );
                  return {
                    ...item1,
                    ...item2,
                  };
                });
                console.log("imgArr========", mergedArray);
                item.json_data.info = mergedArray;
                item.json_data.info.forEach(value =>{
                  value.newProdcut = false;
										if (value.activityList && value.activityList.length != 0) {
											value.activityList.forEach((aItem) => {
												if (aItem.promotionType == 403) { //赠品
                          aItem.promotionName='赠品';
												} else if (aItem.promotionType == 405) {
													// mxList=mxList.concat(aItem.descriptionList)

												} else if (aItem.promotionType == 402) {
													// yhqlist=yhqlist.concat(aItem.descriptionList)

												} else if (aItem.promotionType == 103) {
													// item.hasAct=1;
													// item.promotionType=aItem.promotionType;
													// item.showName='预售';
                          aItem.promotionName='预售';
												} else if (aItem.promotionType == 106) {
													// item.hasAct=1;
													// item.promotionType=aItem.promotionType;
													// item.showName='抢购';
                          aItem.promotionName='限时';
												} else if (aItem.promotionType == 107) {
													// item.hasAct=1;
													// item.promotionType=aItem.promotionType;	
													// item.showName='预约';	
                          aItem.promotionName='预约';
												} else if (aItem.promotionType == 501) {
													// item.hasAct=1;
													// item.firstOrder=1; 
													// item.promotionType=aItem.promotionType;	
													// item.showFirstName='首单';	
                          aItem.promotionName='专享';
												} else if (aItem.promotionType == 408) { //新品  									
													value.newProdcut = true;
													// item.promotionType=aItem.promotionType;
												} else if (aItem.promotionType == 406) {
                          aItem.promotionName='';
												} 
											})

											// tmpList=zplist.concat(mxList)
											// tmpList=tmpList.concat(yhqlist)								
											// item.actShowList=tmpList;	
										}
                })
              }
            });
          }
        });
    };
    const getCouponList = async (data) => {
      let ids = [];
      data.data.forEach((i) => {
        ids.push(i.couponId);
      });
      let param = {
        couponIds: ids,
      };
      let config = {
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
      };
      proxy
        .$post("/v3/promotion/front/coupon/diyHomeCouponList", param, config)
        .then((res) => {
          if (res.state == 200) {
            console.log(res);
            couponData.value = res.data;
            showCoupon.value = true;
            store.commit("saveCouponList", couponData);
            store.commit("saveShowCoupon", showCoupon);
          }
        });
    };
    const getDada = () => {
      // const rect = scrollPage.value.$el
      scrollPage.value.addEventListener("scroll", handleScroll);
    };
    const handleScroll = (event) => {
      // console.log(event);
      if (event.target.scrollTop >= 250) {
        showSideMenu.value = true;
        //showFloor.value = true;
        searchBarFixed.value = true;
      } else if (event.target.scrollTop < 250) {
        showSideMenu.value = false;
        //showFloor.value = false;
        searchBarFixed.value = false;
      }
      // console.log("showSearch========", searchBarFixed.value);
      var viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      var documentHeight = document.body.scrollHeight;
      if (event.target.scrollTop >= 500) {
        //showFloor.value = true;
      }
      
      let set = false;
  
      if (event.target.scrollHeight - event.target.scrollTop < 1500) {
        // console.log(11)
        set = true;
        showFloor.value = false;
      }

      //  liftData.value = decorateData.data.filter(
      //   (i) => i.json_data.type == "text_title"
      // );
      // 处理滚动事件
      proxy.$nextTick(() => {
        // console.log(liftData.value);
        liftData.value.forEach((item, index) => {
          const scrollContainer =
            sldDiyRef.value.$refs["scroll" + item.json.data.id];
          let scrollView = scrollContainer
          if(Array.isArray(scrollContainer)) {
            scrollView = scrollContainer[0];
          }
          // scrollContainer.forEach((item, index) => {
          if (index == 0) {
            if(event.target.scrollTop >=
                scrollView.offsetParent.offsetTop + scrollView.offsetTop - 400){
                if(!set)
                {
                  showFloor.value = true;
                }
                
            }
            if (
              event.target.scrollTop <
                scrollView.offsetParent.offsetTop +
                scrollView.offsetTop -
                200
            ) {
              activeIndex.value = null;
              showFloor.value = false;
              // console.log(activeIndex.value);
            }
          }
      
          if (
            event.target.scrollTop >=
            scrollView.offsetParent.offsetTop + scrollView.offsetTop -
              200
          ) {
            activeIndex.value = index;
            // console.log(activeIndex.value);
          }
          // console.log(event.target.scrollTop,scrollContainer[0].offsetParent.offsetTop,scrollContainer[0].offsetTop);
          // });
        });
      });
    };
    const getOpenScreen = () => {
      // proxy.$post("v3/system/front/pcAdv/list").then((res) => {
      //   if (res.state == 200) {
      //     openScreenData.data = JSON.parse(
      //       res.data.data);
      //     if (
      //       openScreenData.data.imgUrl &&
      //       openScreenData.data.show_switch &&
      //       !route.query.type
      //     ) {
      //       if (JSON.stringify(store.state.openScreenInfo) == "{}") {
      //         openScreenData.data.time = new Date().getTime();
      //         store.commit("updateOpenScreenInfo", openScreenData.data);
      //         show_open_screen.value = true;
      //         document.body.style.overflow = "hidden";
      //       } else if (
      //         store.state.openScreenInfo.show_radio_sele ==
      //         openScreenData.data.show_radio_sele
      //       ) {
      //         if (store.state.openScreenInfo.show_radio_sele == "one") {
      //           if (openScreenData.data.time - new Date().getTime() > 86400) {
      //             openScreenData.data.time = new Date().getTime();
      //             store.commit("updateOpenScreenInfo", openScreenData.data);
      //             show_open_screen.value = true;
      //             document.body.style.overflow = "hidden";
      //           }
      //         } else if (store.state.openScreenInfo.show_radio_sele == "more") {
      //           store.commit("updateOpenScreenInfo", openScreenData.data);
      //           show_open_screen.value = true;
      //           document.body.style.overflow = "hidden";
      //         }
      //       } else {
      //         openScreenData.data.time = new Date().getTime();
      //         store.commit("updateOpenScreenInfo", openScreenData.data);
      //         show_open_screen.value = true;
      //         document.body.style.overflow = "hidden";
      //       }
      //     }
      //   }
      // });
    };
    const dragEvent = (item) =>{
      let params = {
					banner_id: item.advId,
					banner_name: item.data.imgName,
					amall_element_id: 0,
					page_path: route.path,
					page_url: item.data.link_type || item.data.url_type,
					page_type: 1
				}
			proxy.$drgStatEvent('banner_click',params)
    }
    const closeScreen = () => {
      showXcxImage.value = false;
      // document.body.style.overflow = "";
    };
    router.beforeEach((to, from, next) => {
      document.body.style.overflow = "";
      next();
    });

 
    const handleAdv19 = (data) => {
      let tmp_data = decorateData.data.filter(
        (item) => item.dataId == data.dataId
      )[0];
      tmp_data.json_data.data[data.left_or_right_index]["cur_tab"] =
        data.tab_index;
    };
    



    const enterFloor = (item, index) => {
      mouseIndex.value = index;
    };
    const leaveFloor = (item) => {
      mouseIndex.value = null;
    };
    const scrollFloor = (item, index) => {
      // activeIndex.value = index;
      liftData.value.forEach((i) => {
        if (item.json.data.id == i.json.data.id) {
          const scrollContainer =
            sldDiyRef.value.$refs["scroll" + item.json.data.id];
          scrollPage.value.scrollTo({
            // behavior: "smooth",
            top:
              scrollContainer.offsetParent.offsetTop +
              scrollContainer.offsetTop -
              90,
          });
        }

        // console.log(event.target.scrollTop,scrollContainer[0].offsetParent.offsetTop,scrollContainer[0].offsetTop);
        // });
      });
    };
    const goTop = () =>{
      scrollPage.value.scrollTo({
            behavior: "smooth",
            top: 0,
          });
    }

    
    onMounted(() => {
      getAdv();
      getOpenScreen();
      getInitData();
      document.title = "华硕商城ASUS_华硕官网_华硕电脑官方直营商城，购笔记本电脑、轻薄本、游戏本、享一年意外险"
    });

    return {
      adv_21_right_icon,
      adv_24_let_default_pic,
      decorateData,
      firstLoading,
      show_open_screen,
      openScreenData,
      sldDiyRef,
      handleAdv19,
      closeScreen,
      L,
      showCoupon,
      activeIndex,
      advTop,
      liftData,
      couponData,
      scrollPage,
      mouseIndex,
      showSideMenu,
      showFloor,
      topAdvs,
      showXcxImage,
      advImg,
      advInfo,
      showTopImage,
      topImg,
      topInfo,
      closeAd,
      handleScroll,
      getDada,
      scrollFloor,
      leaveFloor,
      enterFloor,
      navTo,
      goTop,
      searchBarFixed,
      pageColor,
      bannerList,
      dragEvent,
      advData,
      topData,
      navList,
      pageGray,
      sideStyle
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/decorate.scss";

// .bottom_line {
//   width: 100%;
// }


.gray-scale {
    filter: grayscale(100%); /* 置灰效果 */
  }

.dianti_wrap {
  position: absolute;
  top: calc(50% - 20px);
  // transform: translateY(-50%);
  width: 100%;
  /* left: 194px; */
  z-index: 9999;
  /* width: 1336px; */
  /* display: flex; */
  /* justify-content: center; */
}

.dianti_center {
  display: flex;
  justify-content: center;
}

.lift_item {
  font-family: Microsoft YaHei,Microsoft YaHei ;
  font-weight: 400;
  font-size: 15px;
  color: #888e98;
  line-height: 22px;
  margin-bottom: 15px;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  /* text-align: end; */
}

.lift_title {
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.lift_line {
  // margin-left: 5px;
  width: 2px;
  height: 12px;
  background: #000000;
}

.active {
  font-family: Microsoft YaHei,Microsoft YaHei ;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  line-height: 22px;
}

.home_adv_con {
  overflow: hidden;
  // height: 100px;
  height: 70px;
  position: relative;
  margin: 0 auto;
  width: 100%; /* 确保广告容器占满父元素的宽度 */
}

.home_adv {
  // background-image: url("../../assets/test_logo.png");
  width: 100%;
  //height: 100px;
  height: 70px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}

// .adv1200 {
//   width: 1920px;
//   height: 100px;
//   margin: 0 auto;
//   position: relative;
// }

.close1 {
  top: 20px;
  right: 15px;
  z-index: 2;
  position: absolute;
  width: 30px;
  height: 30px;
  // background: rgba(0, 0, 0, 0.5);
  // width: 24px;
  // height: 24px;
  // display: flex;
  // align-items: center; /* 垂直居中 */
  // justify-content: center; /* 水平居中 */
  // border-radius: 50%;
  // color: #fff;
  cursor: pointer;
  box-sizing: border-box; /* 确保内边距不影响整体大小 */
  // padding: 3px; /* 添加内边距，使图标与容器边缘有距离 */
  >img{
    width: 30px;
    height: 30px;
  }
}

// .close1 svg {
//   width: 100%;
//   height: 100%;
//   fill: #fff; /* 设置图标颜色 */
// }

.index {
  min-height: 456px;
  // background: #f8f8f8;
  padding-bottom: 10px;
}

.skeleton_banner {
  width: 100%;
  height: 470px;
  background: $colorSkeleton;
  margin-bottom: 10px;
}

.skeleton {
  &.adv_04_wrap .floor_title h2 span {
    background: $colorSkeleton;
    display: inline-block;
    width: 200px;
  }

  &.adv_04_wrap .floor_goods .item .wrap .title {
    background: $colorSkeleton;
    width: 100%;

    a {
      color: transparent;
    }
  }

  &.adv_04_wrap .floor_goods .item .wrap .price {
    width: 100%;
    height: 25px;
  }

  &.adv_04_wrap .floor_goods .item .wrap .price span {
    display: inline-block;
    width: 70px;
    height: 100%;
    background: $colorSkeleton;
  }
}


  // .item_list::-webkit-scrollbar{
  //   width: 5px;
  // }
  .side_menu {
    position: absolute;
    top: calc(100vh - 676px);
    right: 30px;
    z-index: 999;
  }

</style>
